
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";



import { useGetRoleQuery, useGetRoleListQuery, useGetRolePresentationQuery } from "../../../../auth/apis/Role.api";
import { RoleNameDisplay, default as RoleName } from "../../../../auth/components/role/RoleDetail/RoleName";
import { toString as toStringRole, PrimaryRole } from "../../../../auth/types/models/Role";

import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";
import Search from "@mui/icons-material/Search";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import ManageSearch from "@mui/icons-material/ManageSearch";
import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";




export const initialFormStateFn = () => { return {
    
        roleId: [],
        
    
    
} }

export const formObject = {
    
        roleId: array(string()
            .nullish()),
        
        
    
        permission: string()
        .trim()
        .nullish(),
        
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;



type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const RolePermissionListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('RolePermission')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const { data: roleList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getRoleListLoading,
        isFetching: getRoleListFetching, 
    } = useGetRoleListQuery()
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="RolePermission-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Role, Permission)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="RolePermission-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'roleId' }
                optionsLoading={ getRoleListLoading || getRoleListFetching }
                label={t`Role`}
                options={ roleList.items }
                valueMap={ (id) => useGetRoleQuery(PrimaryRole.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringRole }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><RoleNameDisplay data={option}/></li>)
                } }
                
                
                renderTags={(value: readonly string[], getTagProps) =>
                    value.map((option: any, index: number) => {
                        const { key, ...tagProps } = getTagProps({ index })
                        return (
                            <crudgen.SelectChip key={key} {...tagProps}>
                                <RoleName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
        />
        
    

                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'permission' }
                    label={t`Permission`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default RolePermissionListSearch;
